jQuery(document).ready(function(){
    //LAZYLOAD
    jQuery("img").each(function(){
        var image = jQuery(this);
        var parent = image.parent().attr('class');
        if (image.parent().attr("id") != "diago" &&
            image.parent().parent().attr("id") != "logo_lyon1" &&
            image.parent().parent().parent().attr("id") != "sliderArticles" &&
            image.parent().parent().attr("id") != "logo_comue" &&
            image.attr("id") != "logo" ) {

            if (parent && parent.indexOf("slide") > -1) {
                image.addClass("lazyContainer");
            } else {
                // Crée data-original uniquement si absent
                // if (!image.attr("data-original")) {
                   //  image.attr("data-original", image.attr("src"));
                // }
                // image.attr('src','/common/scripts/lazyload/load.jpg');
                // image.addClass('lazy');
            }
        }
    });
});